import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { useTranslation } from 'react-i18next';
import { FormGroup } from './form-inputs/FormGroup';

export const AgeInput: React.FC<
    {
        value?: number;
        onChange: (_: number) => void;
        maxAge?: number;
        minAge?: number;
        onBlurAction?: (_: undefined | number) => void;
    } & React.ComponentProps<typeof FormGroup>
> = ({ value, onChange, maxAge = 75, minAge, onBlurAction, ...rest }) => {
    const { t } = useTranslation('pension');
    const suffix = value ? t('general-year-no-capital') : t('general-year');

    const getValidAgeValue = (newValue: number) => {
        return Math.max(minAge ?? 0, Math.min(maxAge, newValue));
    };

    return (
        <FormGroup {...rest}>
            <CurrencyInput
                allowNegativeValue={false}
                type="text"
                suffix={suffix}
                className={'py-2 px-4 border border-gray-200 rounded-lg focus:outline-hidden font-medium'}
                fixedDecimalLength={0}
                decimalsLimit={2}
                allowDecimals={false}
                onBlur={() => {
                    if (value === undefined) return;

                    const newAge = getValidAgeValue(value);
                    if (onBlurAction) onBlurAction(newAge);
                    else onChange(newAge);
                }}
                value={value ? value : undefined}
                onValueChange={(newValue = '', _) => {
                    const ageAsNumber = +newValue;
                    const validAge = getValidAgeValue(ageAsNumber);
                    const newFilledInAge = validAge > ageAsNumber ? ageAsNumber : validAge;
                    onChange(newFilledInAge);
                }}
                placeholder={suffix}
            />
        </FormGroup>
    );
};
